interface TaskFormLayerInfoProps {
  formData: {
    layer_name?: string;
    asset_field?: string;
    asset_id?: string;
  };
  isViewMode: boolean;
}

export const TaskFormLayerInfo: React.FC<TaskFormLayerInfoProps> = ({
  formData,
  isViewMode,
}) => {
  if (!formData.layer_name && !formData.asset_field && !formData.asset_id) {
    return null;
  }

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
      <label className="block text-sm font-medium text-gray-700 mb-3">
        Layer Information
      </label>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {formData.layer_name && (
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">
              Layer Name
            </label>
            <input
              type="text"
              value={formData.layer_name}
              readOnly
              className={`w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-gray-100 text-gray-700 ${isViewMode ? "cursor-not-allowed" : ""}`}
              disabled={isViewMode}
            />
          </div>
        )}
        {formData.asset_field && (
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">
              Asset Field
            </label>
            <input
              type="text"
              value={formData.asset_field}
              readOnly
              className={`w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-gray-100 text-gray-700 ${isViewMode ? "cursor-not-allowed" : ""}`}
              disabled={isViewMode}
            />
          </div>
        )}
        {formData.asset_id && (
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">
              Asset ID
            </label>
            <input
              type="text"
              value={formData.asset_id}
              readOnly
              className={`w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-gray-100 text-gray-700 ${isViewMode ? "cursor-not-allowed" : ""}`}
              disabled={isViewMode}
            />
          </div>
        )}
      </div>
    </div>
  );
};
